import apiClient from '../../shared/services/apiClient';

/** 观测点 / 探测设置 / 回源质量 / anycast 总览(admin) */
const wrap = async (fn) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

const cdnProbeService = {
  getVantages() {
    return wrap(() => apiClient.get('/api/admin/cdn/probe-vantages'));
  },
  updateVantage(id, disabled) {
    return wrap(() => apiClient.post('/api/admin/cdn/probe-vantages/update', { id, disabled }));
  },
  getOriginRoutes() {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-routes'));
  },
  getOriginGroupRoutes() {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-group-routes'));
  },
  pinOriginGroupRoute(colo, groupId, via) {
    return wrap(() => apiClient.post('/api/admin/cdn/origin-group-routes/pin', { colo, group_id: groupId, via }));
  },
  getOriginGroups(q) {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-groups', { params: { q } }));
  },
  pinOriginRoute(nodeId, prefix, via) {
    return wrap(() => apiClient.post('/api/admin/cdn/origin-routes/pin', { node_id: nodeId, prefix, via }));
  },
  getSettings() {
    return wrap(() => apiClient.get('/api/admin/cdn/probe-settings'));
  },
  saveSettings(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/probe-settings', data));
  },
  getOriginMatrix(window) {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-quality', { params: { window } }));
  },
  getOriginDetail(targetId, nodeId) {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-quality/detail', { params: { target_id: targetId, node_id: nodeId } }));
  },
  saveOriginTarget(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/origin-targets/save', data));
  },
  deleteOriginTarget(id) {
    return wrap(() => apiClient.post('/api/admin/cdn/origin-targets/delete', { id }));
  },
  searchDomainOrigins(q) {
    return wrap(() => apiClient.get('/api/admin/cdn/origin-targets/domain-origins', { params: { q } }));
  },
  getGlobalProbe(hours) {
    return wrap(() => apiClient.get('/api/admin/cdn/global-probe', { params: { hours } }));
  },
  saveGlobalProbeSettings(data) {
    return wrap(() => apiClient.post('/api/admin/cdn/global-probe/settings', data));
  },
  runGlobalProbe() {
    return wrap(() => apiClient.post('/api/admin/cdn/global-probe/run'));
  },
  getAnycast() {
    return wrap(() => apiClient.get('/api/admin/cdn/anycast'));
  },
  setClusterAnycastDns(id, on) {
    return wrap(() => apiClient.post('/api/admin/cdn/anycast/cluster', { id, anycast_dns: on }));
  },
  setLineAnycastOff(id, off) {
    return wrap(() => apiClient.post('/api/admin/cdn/anycast/line', { id, anycast_off: off }));
  },
};

export default cdnProbeService;
